import React from 'react';
import bike from '../../assets/projects/t1.png'
import bike2 from '../../assets/projects/t2.png'
import bike3 from '../../assets/projects/t3.png'
const TravelG = () => {
    return (
        <div>
              <div>
                    <div className='grid lg:grid-cols-2 w-9/12 mx-auto  gap-4'>
            <div className='lg:mt-64 mt-32'>
                  
                    <img src={bike} alt="" className='mb-5'/>
                    <img src={bike2} alt="" className='mb-5'/>
                    <img src={bike3} alt="" />
            </div>

            <div className='lg:mt-64 mb-32'>
                <p className='text-4xl text-orange-500 text-center '>Travel G</p>
                <p className='lg:ml-10 mt-5'>A fully responsive website where user can take any tour guide services </p>

                <h2 className='text-2xl mt-4 text-center'>Features</h2>
                <p className='ml-8 mt-8'>1. Responsive </p>
                <p className='ml-8 mt-8'>2. Firebase Authenticetion </p>
                <p className='ml-8 mt-8'>3. Users can take service and review the service.Needs login to add review.
</p>
                <p className='ml-8 mt-8'>4. Users can see others' reviews of each service .
</p>
                <p className='ml-8 mt-8'>5. Stirpe payment system</p>

               <p className='ml-8 mt-9'>Live Link: <a href="https://resale-vehicle.web.app/"><span className='text-green-400'>https://resale-vehicle.web.app/</span></a> </p>
               <p className='ml-8 mt-9'>Github Code: <a href="https://github.com/SHAON1028/Resale-client"><span className='text-green-400'>https://github.com/SHAON1028/Resale-client</span></a> </p>
            </div>
            
        </div>
        </div>
        </div>
    );
};

export default TravelG;